import { configureStore } from "@reduxjs/toolkit";
import { setAuthAction } from "../toolkit/auth/authReducer";
import { signupApi } from "../toolkit/auth/signup/signupApi";
import { sellerApi } from "../toolkit/seller/sellerApi";
import { carDetailsApi } from "../toolkit/carDetails/carDetailsApi";
import { liveAuctionApi } from "../toolkit/liveAuction/liveAuctionApi";
import { myGarageApi } from "../toolkit/myGarage/myGarageApi";
import { sellMyCarApi } from "../toolkit/sellMyCar/sellMyCarApi";
import { signinApi } from "../toolkit/signin/signinApi";
import { upcomingCarsApi } from "../toolkit/upcomingCars/upcomingCarsApi";
import { savedData } from "../utils/constants/localStorage";
import { reducerPaths } from "./reducerPaths";
import { rootReducer } from "./rootReducer";
import { carsInNegotiationApi } from "../toolkit/carsInNegotiation/carsInNegotiationApi";
import { carEstimateApi } from "../toolkit/carEstimate/carEstimateApi";
import { vehicleApi } from "../toolkit/vehicle/vehicleApi";
import { contactUsApi } from "../toolkit/contactUs/contactUsApi";
import { geographyApi } from "../toolkit/geography/geographyApi";
import { paypalApi } from "../toolkit/paypal/paypalApi";
import { carfaxApi } from "../toolkit/carfax/carfaxApi";
import { buyNowApi } from "../toolkit/buyNow/buyNowApi";
import { myOrdersApi } from "src/toolkit/myOrders/myOrdersApi";
import { dashboardPaginationFiltersApi } from "src/toolkit/dashboardPaginationFilters/dashboardPaginationFiltersApi";
import { rejectedCarsApi } from "src/toolkit/rejectedCars/rejectedCarsApi";
import { paymentsApi } from "src/toolkit/payments/paymentsApi";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      // serializableCheck: {
      //   ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      // },
      // serializableCheck: false,
    })
      .concat(signinApi.middleware)
      .concat(sellerApi.middleware)
      .concat(vehicleApi.middleware)
      .concat(myGarageApi.middleware)
      .concat(sellMyCarApi.middleware)
      .concat(upcomingCarsApi.middleware)
      .concat(buyNowApi.middleware)
      .concat(liveAuctionApi.middleware)
      .concat(signupApi.middleware)
      .concat(carDetailsApi.middleware)
      .concat(carsInNegotiationApi.middleware)
      .concat(carEstimateApi.middleware)
      .concat(contactUsApi.middleware)
      .concat(geographyApi.middleware)
      .concat(paypalApi.middleware)
      .concat(carfaxApi.middleware)
      .concat(myOrdersApi.middleware)
      .concat(rejectedCarsApi.middleware)
      .concat(dashboardPaginationFiltersApi.middleware)
      .concat(paymentsApi.middleware)
});

// let persistor = persistStore(store);

// --------------------------------------------------------------------------------------------------------
const populateReduxStoreFromLocalStorageHandler = () => {
  const parsedLocalStorage = JSON.parse(localStorage.getItem(savedData.state));

  if (parsedLocalStorage) {
    store.dispatch(setAuthAction(parsedLocalStorage[reducerPaths.auth]));
  }
};

populateReduxStoreFromLocalStorageHandler();
// --------------------------------------------------------------------------------------------------------

// let previousSellMyCarDashboardState = store.getState().sellMyCarDashboard;
let previousAuthState = store.getState().auth;

const unsubscribe = store.subscribe(() => {
  // const currentSellMyCarDashboardState = store.getState().sellMyCarDashboard;
  // if (currentSellMyCarDashboardState !== previousSellMyCarDashboardState) {
  //   let localStorageState = JSON.parse(localStorage.getItem(savedData.state));
  //   localStorageState = {
  //     ...localStorageState,
  //     sellMyCarDashboard: currentSellMyCarDashboardState
  //   };

  //   localStorage.setItem(savedData.state, JSON.stringify(localStorageState));
  //   // Perform your action here when sellerSidebar changes
  //   // For example, you might want to log something, trigger another action, etc.
  //   previousSellMyCarDashboardState = currentSellMyCarDashboardState; // Update the previous state
  // }

  const currentAuthState = store.getState().auth;
  if (currentAuthState !== previousAuthState) {
    let localStorageState = JSON.parse(localStorage.getItem(savedData.state));
    localStorageState = {
      ...localStorageState,
      auth: currentAuthState,
    };

    localStorage.setItem(savedData.state, JSON.stringify(localStorageState));
    // Perform your action here when sellerSidebar changes
    // For example, you might want to log something, trigger another action, etc.
    previousAuthState = currentAuthState; // Update the previous state
  }
});

export default store;
// export {
//   persistor
// };
